<template>
  <v-layout column>
    <v-flex xs6 offset-xs0 px-2>
      <panel title="Register">
        <div slot="top">
          <v-text-field v-model="email" required :rules="[required]" label="Email" />
          <br/>
          <v-text-field v-model="username" required :rules="[rules.required, rules.min]" label="Name" />
          <br/>
          <v-text-field v-model="password" required 
          autocomplete="new-password" label="Password"
          :append-icon="showP ? 'visibility' : 'visibility_off'"
          :type="showP ? 'text' : 'password'"
          counter
          @click:append="showP = !showP"
          :rules="[rules.required, rules.min]"
          hint="At least 8 characters"/>
          <br/>
          <div class="error" v-html="error">
          </div>
          <div class="message" v-html="message">
          </div>
          <br/>
          <v-btn dark class="indigo darken-1" @click='register'>Register</v-btn>
        </div>
      </panel>
    </v-flex>
  </v-layout>
</template>

<script>
import Panel from '@/components/Panel'
import AuthenticationService from '@/services/AuthenticationService'
export default {
  components: {
    Panel
  },
  data () {
    return {
      email: '',
      username: '',
      password: '',
      error: null,
      message: null,
      required: (value) => !!value || 'Required.',
      showP: true,
      rules: {
        required: value => !!value || 'Required.',
        min: v => v.length >= 8 || 'Min 8 characters'
      }   
    }
  },
  methods: {
    async register () {
      this.error = null
      try {
        const response = await AuthenticationService.register({
          email: this.email,
          username: this.username,
          password: this.password
        })
        this.$store.dispatch('setToken', response.data.token)
        this.$store.dispatch('setUser', response.data.user)
        console.log(response.data)
        
        this.message = response.data.message
      }
      catch (error) {
        this.error = error.response.data.error ;
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.error {color:white}
.message {color:green}
.input-group00text-field input {
  border-bottom: 1px solid black ;
}

</style>



// WEBPACK FOOTER //
// src/components/Register.vue